import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { formatDate } from '@/utils/dateHelper';
import CardItem from '@/components/cards/CardItem';
import CardHeader from '@/components/cards/CardHeader';
import AuditWhoLink from './AuditWhoLink';
import AuditResourceLink from './AuditResourceLink';
import { auditIcon } from '../constants';

const AuditCardItem = ({
  allowCohortLink,
  allowCollectionLink,
  allowDatasetLink,
  allowRequestLink,
  allowRoleLink,
  allowSearchLink,
  allowUserLink,
  allowUserGroupLink,
  audit,
  withMeta,
}) => (
  <CardItem className="aridhia-audit-list-item">
    <Card.Content>
      <CardHeader icon={auditIcon(audit.primary_entity)} text={formatDate(audit.when)} />
      {withMeta && (
      <Card.Meta>
        <FormattedMessage id="audit.resource" />
        <AuditResourceLink
          allowCohortLink={allowCohortLink}
          allowCollectionLink={allowCollectionLink}
          allowDatasetLink={allowDatasetLink}
          allowRequestLink={allowRequestLink}
          allowRoleLink={allowRoleLink}
          allowSearchLink={allowSearchLink}
          allowUserGroupLink={allowUserGroupLink}
          allowUserLink={allowUserLink}
          entity={audit.primary_entity}
          name={audit.primary_name}
          route={audit.primary_route}
        />
      </Card.Meta>
      )}
      <Card.Description content={audit.what} />
    </Card.Content>
    {audit.user_name && (
    <Card.Content extra>
      <FormattedMessage id="audit.who" />
      <AuditWhoLink allowUserLink={allowUserLink} allowUserGroupLink={allowUserGroupLink} audit={audit} />
    </Card.Content>
    )}
  </CardItem>
);

export default AuditCardItem;
